import styled from '@emotion/styled'
import { Button } from 'antd'

export const ManageRoot = styled.div`
  display: flex;
  gap: 24px;
  flex-direction: column;
`

export const ContentCard = styled.div<{ padding?: number }>(
  ({ padding = 24 }) => `
  margin: 0 auto;
  width: 100%;
  max-width: 640px;
  padding: ${padding}px 24px;
  background-color: #fff;
  border-radius: 6px;
`
)

export const PageDescription = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: #4a4a68;
  margin-bottom: 24px;
`

export const DeleteButton = styled(Button)`
  color: #a40000;
  background: transparent;
  border: 1px solid #a40000;

  &:disabled,
  &:hover,
  &:focus,
  &:active {
    color: #a40000;
    background: transparent;
    border: 1px solid #a40000;
  }

  &:disabled {
    opacity: 0.4;

    &:hover,
    &:focus,
    &:active {
      color: #a40000;
      background: transparent;
      border: 1px solid #a40000;
    }
  }
`

export const RemoveButton = styled(Button)`
  display: flex;
  align-items: center;

  font-size: 12px;
  font-weight: 400;
  text-transform: capitalize !important;
  color: #a40000;
  border: none;

  &:hover,
  &:focus,
  &:active {
    color: #a40000;
    background: transparent;
    border: none;
  }
`

export const Card = styled.div<{
  isLoading?: boolean
  gap?: number
  marginBottom?: number
  borderColor?: string
}>(
  ({ isLoading, gap = 16, marginBottom = 24, borderColor = '#a4a4b3' }) => `
  position: relative;

  display: flex;
  flex-direction: column;
  gap: ${gap}px;

  padding: 12px;
  border: 1px solid ${borderColor};
  border-radius: 4px;
  margin-bottom: ${marginBottom}px;

  ${
    isLoading &&
    `
      .ant-select-selector {
        position: relative;
        z-index: 0;

        &::after{
          content:'';
          position: absolute;
          left:0;
          top:0;
          border-radius: 5px;
          display: inline-flex;
          visibility:visible;
          width: 100%;
          height: 100%;
          z-index: 3;
          background-size: 200% 100%;
          background-image: linear-gradient(90deg, #f8f8f8 0, #ededed 10%, #f8f8f8 15%, #f8f8f8 55%, #ededed 65%, #f8f8f8 70%);
          animation: shimmer 3s linear infinite
        }
      }

      @keyframes shimmer {
        0% {
          background-position: 100%;
        }
        100% {
          background-position: -100%;
        }
      }
    `
  }
`
)

export const FormLabel = styled.div(
  ({ marginBottom = 8 }: { marginBottom?: number }) => `
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: ${marginBottom}px;
`
)

export const FormItemTitle = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #4a4a68;
  line-height: 1;
`

export const FormItemDescription = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: #77778e;
  line-height: 1.2;
`
